import moment from "moment";
import {
  GET_LIVE_COURSE_SESSION,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SET_MODULE_ID,
} from "../../shared/constants/ActionTypes";

const initialLiveCourseSession = {
  liveCourseSession: [],
  liveCourseSessionCount: 0,
  page: 1,
  search: "",
  courseId: "",
  moduleId: "",
};

const liveCourseSessionReducer = (state = initialLiveCourseSession, action) => {
  switch (action.type) {
    case GET_LIVE_COURSE_SESSION:
      return {
        ...state,
        liveCourseSession: action.payload.sessoins.map((liveSession) => {
          return {
            ...liveSession,
            title: liveSession.webexMeeting?.title,
            end_datetimeFormatted: moment(liveSession.webexMeeting.end).format(
              "lll"
            ),
            start_datetimeFormatted: moment(
              liveSession.webexMeeting.start
            ).format("lll"),
            updatedAtFormatted: moment(liveSession.createdAt).format("ll"),
          };
        }),
        liveCourseSessionCount: action.payload.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_MODULE_ID:
      return {
        ...state,
        moduleId: action.payload,
      };
    default:
      return state;
  }
};

export default liveCourseSessionReducer;
